/**
 * Marker prefix for CharacterMemory variable references in the text
 * importer/exporter format. See docs/features/skins/text-format-contract.md.
 *
 * Centralized in one constant so the prefix can be changed in a single place
 * without ripple changes through parsers and validators.
 *
 * The prefix match is case-insensitive (`memory.`, `Memory.`, `MEMORY.` all
 * recognized) so authors do not have to remember a specific casing.
 */
export const CHARACTER_MEMORY_PREFIX = 'memory.';

export function isCharacterMemoryToken(token: string | undefined | null): boolean {
  if (!token) return false;
  return token.toLowerCase().startsWith(CHARACTER_MEMORY_PREFIX);
}

export function stripCharacterMemoryPrefix(token: string): string {
  return isCharacterMemoryToken(token)
    ? token.slice(CHARACTER_MEMORY_PREFIX.length)
    : token;
}
